import React, { useEffect, useState } from 'react';
import { ReactComponent as LogoLight } from '../assets/logo_light.svg';
import { ReactComponent as LogoDark } from '../assets/logo_dark.svg';
import { routeIds } from '../i18n/routes';
import { useI18n } from '../i18n/I18nContext';
import LanguageMenu from './LanguageMenu';

function TabAnchor({ style, selected, href, content }) {
  const color = style === "dark" ? "text-white" : "text-dark";
  const font = selected ? "font-bold" : "font-medium";
  return (
    <li><a className={`${color} text-lg ${font} lowercase transition duration-300 hover:opacity-50`} href={href} aria-current={selected ? 'page' : undefined}>{content}</a></li>
  );
}

function Header({ route }) {
  const [scrolled, setScrolled] = useState(() => window.scrollY > 48);
  const style = scrolled ? 'light' : route.style;
  const drawer = route.drawer;
  const { pathFor, t } = useI18n();
  
  const setDrawerVisible = drawer[1];
  const path = route.status < 400 ? route.path : "/not-found";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 48);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className={`site-header fixed top-0 w-full z-40 ${scrolled ? 'is-scrolled' : ''}`}>
      <div className="flex max-w-[1200px] mx-auto relative z-20 items-center h-full">
        <nav className="flex items-center w-full h-full">
          <a className="site-brand transition duration-300 hover:opacity-50" aria-label="CDO Apps" href={pathFor(routeIds.home)}>{style === "dark" ? <LogoDark className="text-white" /> : <LogoLight className="text-dark" />}</a>
          <div className="flex-grow lg:hidden"></div>
          <ul className="hidden lg:flex gap-6 xl:gap-12 mx-auto px-2.5">
            <TabAnchor style={style} href={pathFor(routeIds.expertise)} content={t("navigation.expertise")} selected={path.startsWith("/expertises")} />
            <TabAnchor style={style} href={pathFor(routeIds.projects)} content={t("navigation.projects")} selected={path.startsWith("/realisations")} />
            <TabAnchor style={style} href={pathFor(routeIds.team)} content={t("navigation.team")} selected={path.startsWith("/equipe")} />
            <TabAnchor style={style} href={pathFor(routeIds.contact)} content={t("navigation.contact")} selected={path.startsWith("/contact")} />
          </ul>
          <div className="hidden lg:flex">
            <LanguageMenu variant={style} />
          </div>
          <button
            type="button"
            aria-label={t('navigation.openMenu')}
            aria-expanded={drawer[0]}
            aria-controls="navigation-drawer"
            className={`lg:hidden ${style === 'dark' ? 'text-white' : 'text-dark'} font-bold text-4xl transition duration-300 hover:opacity-50`}
            onClick={() => setDrawerVisible(true)}>
            ☰
          </button>
        </nav>
      </div>
    </div>
  );
}

export default Header;
